import React from "react";

import {
  Form,
  Col,
  Row,
  message,
  Input,
  Layout,
  Button,
  DatePicker,
  Radio,
  Modal,
  Empty,
} from "antd";
import MiCompAPI from "../../util/api";

import img from "../../assets/img/At the office-pana 1.png";
import AddField from "./AddField";
const { Content } = Layout;

class FD extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: [],
      dataF: [],
      isPreview: false,
      dragover: false,
      inProgress: [],
      Done: [],
      visible: false,
      template: null,
      fieldLabelName: null,
      addfield: false,
      allFields: true,
      isEdit:true,   
    };

    this.api = new MiCompAPI(this.props.userPermandMasters);
  }

  componentDidMount() {
    this.GetAllMasterFields();
    setTimeout(() => {
      if (this.props.location.state) {
        this.api.invoke(       
          "GetSRTemplateById/" + this.props.location.state,
          "get",
          (data, success) => {
            if (success) {
              if (data.statusCode === 200) {
                let daF = data.data.fields;

                this.setState({
                  template: data.data,
                  Done: [
                    ...this.state.Done,
                    ...daF.map((x) => {
                      return { ...x, type: "Done" };
                    }),
                  ],
                  inProgress: this.state.inProgress.filter(
                    (x) => !daF.find((a) => a.fieldID === x.fieldID)
                  ),

                  dataF: this.state.dataF.map((x) => {
                    if (daF.find((a) => a.fieldID === x.fieldID)) {
                      x.type = "Done";
                      x.id = daF.find((a) => a.fieldID === x.fieldID).id;
                    } else {
                      x.type = "inProgress";
                    }
                    return x;
                  }),
                });
              } else {
                message.destroy();
                message.error(data.statusMessage, 3);
              }
            }
          }
        );
      }
    }, 1000);
  }
  search = (type, value) => {
    if (type === "fieldLabelName") {
      this.setState({
        dataF: value,
      });
    }
  };
  searchtext = (e) => {
    this.setState({
      inProgress: this.state.dataF.filter(
        (x) =>
          (x.type =
            "inProgress" &&
            x.fieldLabelName
              .toLowerCase()
              .includes(e.target.value.toLowerCase()))
      ),
    });
  };
  GetAllMasterFields() {
    this.api.invoke("GetAllMasterFields", "get", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          let dataF = data.data.map((x) => {
            return { ...x, type: "inProgress" };
          });
          this.setState({
            allFieldsLoading: false,
            dataF: dataF.map((x) => {
              return { ...x, id: 0 };
            }),
            Done: [
              ...this.state.Done,
              ...dataF.filter((x) => x.type === "Done"),
            ],
            inProgress: dataF.filter((x) => x.type === "inProgress"),
          });
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
    });
  }

  handleClick = (e) => {
    this.InsertAndUpdateSRTemplate({
  
      template_Name: this.state.template && this.state.template.template_Name,
      template_Description:
        this.state.template && this.state.template.template_Description,
      templateId: this.props.location.state,
      fields: this.state.Done.map((x, i) => {
        return {
          id: x.id,
          fieldId: x.fieldID,
          align_Sort_By: i + 1,
          is_Mandatory: false,
        };
      }),
    });
  };
  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.InsertAndUpdateSRTemplate({
          ...values,
          templateId: 0,

          fields: this.state.Done.map((x, i) => {
            return {
              id: 0,
              fieldId: x.fieldID,
              align_Sort_By: i + 1,
              is_Mandatory: false,
            };
          }),
        });
      }
    });
  };
  InsertAndUpdateSRTemplate = (data) => {
    this.api.invoke(
      "InsertAndUpdateSRTemplate",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              visible: false,
            });

            this.props.history.push("/administration/managetemplate");

            message.destroy();
            message.success(data.statusMessage, 3);
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        } else {
        }
      },
      data
    );
  };
  InsertAndUpdateSRField = (data, callback) => {
    this.api.invoke(
      "InsertAndUpdateMasterFields",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({ addfield: false });
            this.GetAllMasterFields();
            message.destroy();
            message.success(data.statusMessage, 3);
            this.CloseHandlerfield();
            callback(true);
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
            callback(false);
          }
        } else {
        }
      },
      data
    );
  };
  CloseHandlerfield = () => {
    this.setState({ addfield: false });
  };
  onChange = (e) => {
    this.setState({
      gender: e.target.value,
    });
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Content>
        <Modal visible={this.state.visible}>
          <div className="mi_model_popup">
            <Form
              onSubmit={this.handleSubmit}
              layout="vertical"
              hideRequiredMark
            >
              <Row span={24}>
                <Col span={18}>
                  <p style={{ marginLeft: "14px" }} className="mi_title">             
                     Add Template 
                  </p>
                </Col>
                <Col span={6}>
                  <i
                    className="fa fa-times mi_icon mi_icon_red mi_button_close"
                    style={{ color: "red" }}
                    onClick={() =>
                      this.setState({
                        visible: false,
                      })
                    }
                  ></i>
                </Col>
              </Row>

              <Row span={24}>
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">Template Name</legend>

                      {getFieldDecorator("template_Name", {
                        rules: [
                          {
                            required: true,
                            message: "Please Enter Template Name",
                          },
                        ],
                      })(
                        <Input
                          className="mi_input"
                          maxLength={40}
                          type="text"
                          placeholder="Please enter Template Name *"
                        />
                      )}
                    </fieldset>
                  </Form.Item>
                </Col>
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">
                        Template Description
                      </legend>
                      {getFieldDecorator("template_Description", {
                        rules: [
                          {
                            required: true,
                            message: "Please enter Template Description.",
                          },
                        ],
                      })(
                        <Input
                          type="text"
                          autoComplete={"nope"}
                          className="mi_input"
                          placeholder="Enter Template Description*"
                        />
                      )}
                    </fieldset>
                  </Form.Item>
                </Col>
              </Row>

              <Row span={24} style={{ marginTop: "30px" }}>
                <Col span={7}></Col>

                <Col span={5}>
                  <Button
                    className="mi_button_right submit-button"
                    onClick={() =>
                      this.setState({
                        visible: false,
                      })
                    }
                    style={{ marginRight: 8 }}
                  >
                    Cancel
                  </Button>
                </Col>
                <Col span={5}>
                  <Button
                    htmlType="submit"
                    className="submit-button"
                    type="primary"
                  >
                    Submit
                  </Button>
                </Col>
                <Col span={7}>
                  <img
                    alt="example"
                    style={{
                      height: "70px",
                      marginBottom: "-30px",
                      float: "right",
                    }}
                    src={img}
                  />
                </Col>
                <Col span={7}></Col>
              </Row>
            </Form>
          </div>
        </Modal>
        <div className="mi_main_div" style={{ padding: "40px" }}>
          <div className="mi_box">
            <Row span={24}>
              <Col span={18}>
                {!this.state.isPreview ? (
                  <h4 className="mi_box_h4"> Add Templates</h4>
                ) : (
                  <h4 className="mi_box_h4"> Preview Templates</h4>
                )}
              </Col>
              <Col span={6}>
                <img
                  alt="example"
                  style={{ height: "182px", marginTop: "-80px" }}
                  src={img}
                />
              </Col>
            </Row>
          </div>
          <div style={{ marginLeft: "-8px", marginRight: "-8px" }}>
            <div className="mi_main">
              {!this.state.isPreview ? (
                <Row span={24} type="flex">
                  <Col span={10}>
                    <p
                      className="mi_title"
                      style={{ color: "rgb(253, 130, 141)" }}
                    >
                      {" "}
                      Available Fields
                    </p>

                    {
                      <>
                        <Row>
                          <Col md={24} sm={24}>
                            <div
                              style={{
                                marginRight: "15px",

                                marginTop: "-40px",
                              }}
                            >
                              <Input.Search
                                style={{
                                  width: "150px",
                                }}
                                placeholder="Search "
                                className="table-search-button"
                                onChange={this.searchtext}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <div
                            className="center-col "
                            style={{ height: 400, marginTop: "10px" }}
                          >
                            {this.state.inProgress &&
                              this.state.inProgress.map((data, i) => {
                                return (
                                  <div
                                    key={i}
                                    style={{
                                      padding: "8px",
                                      width: "100%",
                                      border: "2px solid #d9d9d9",
                                      margin: "6px 0px",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    <Row span={24}>
                                      <Col span={22}>
                                        <p
                                          className="mi_value"
                                          style={{
                                            marginBottom: "4px",
                                            marginTop: "2px",
                                          }}
                                        >
                                          {data.fieldLabelName}
                                        </p>
                                      </Col>

                                      <Col
                                        span={2}
                                        style={{
                                          marginTop: "2px",
                                          marginBottom: "-8px",
                                        }}
                                      >
                                        <i
                                          style={{
                                            color: "#4e5694",
                                            fontSize: "24px",
                                          }}
                                          
                                          className="fas fa-angle-right "
                                          onClick={() => {
                                            let dataF = this.state.dataF.filter(
                                              (x) => {
                                                if (
                                                 
                                                  x.fieldLabelName ===
                                                  data.fieldLabelName
                                                ) {
                                                  x.type = "Done";
                                                }
                                                return data;
                                              }
                                            );

                                            this.setState({
                                              ...this.state,
                                              dataF,
                                              inProgress: dataF.filter(
                                                (x) => x.type === "inProgress"
                                              ),
                                              Done: dataF.filter(
                                                (x) => x.type === "Done"
                                              ),
                                            });
                                          }}
                                        ></i>
                                         
                                      </Col>
                                    </Row>
                                  </div>
                                );
                              })}
                            <Button
                              style={{ marginTop: "20px", marginLeft: "1px" }}
                              className="submit-button"
                              type="primary"
                              onClick={() => {
                                this.setState({
                                  addfield: true,
                                });
                              }}
                            >
                              Add Field
                            </Button>

                            <Modal visible={this.state.addfield}>
                              <AddField
                                userPermandMasters={
                                  this.props.userPermandMasters
                                }
                                closeDrawerHandler={this.CloseHandlerfield}
                                submitHandler={this.InsertAndUpdateSRField}
                                width="500"
                              />
                            </Modal>
                          </div>
                        </Row>
                      </>
                    }
                  </Col>
                  <Col span={4}></Col>
                  <Col span={10}>
                    <p
                      className="mi_title"
                      style={{ color: "rgb(253, 130, 141)" }}
                    >
                      {" "}
                      Template Fields
                    </p>
                    <div className="center-col " style={{ height: 400 }}>
                      {this.state.Done &&
                        this.state.Done.map((data, i) => {
                          return (
                            <div
                              key={i}
                              draggable
                              className="draggable"
                              style={{
                                padding: "8px",
                                width: "100%",
                                border: "2px solid #d9d9d9",
                                margin: "6px 0px",
                                borderRadius: "10px",
                              }}
                            >
                              <Row span={24}>
                                <Col span={22}>
                                  <p
                                    style={{
                                      marginBottom: "4px",
                                      marginTop: "2px",
                                    }}
                                    className="mi_value"
                                  >
                                    {data.fieldLabelName}
                                  </p>
                                </Col>
                                {data.type === "Done" && (
                                  <Col
                                    span={2}
                                    style={{
                                      marginTop: "2px",
                                      marginBottom: "-8px",
                                    }}
                                  >
                                    <i
                                      style={{
                                        color: "#4e5694",
                                        fontSize: "24px",
                                      }}
                                      className="fas fa-angle-left"
                                      onClick={() => {
                                        let dataF = this.state.dataF.filter(
                                          (x) => {
                                            if (
                                              x.fieldLabelName ===
                                              data.fieldLabelName
                                            ) {
                                              x.type = "inProgress";
                                            }
                                            return data;
                                          }
                                        );

                                        this.setState({
                                          ...this.state,
                                          dataF,
                                          Done: dataF.filter(
                                            (x) => x.type === "Done"
                                          ),
                                          inProgress: dataF.filter(
                                            (x) => x.type === "inProgress"
                                          ),
                                        });
                                      }}
                                    ></i>
                                  </Col>
                                )}
                              </Row>
                            </div>
                          );
                        })}
                    </div>
                  </Col>
                  <Col span={4}></Col>
                </Row>
              ) : (
                <Form layout="vertical" hideRequiredMark>
                  {this.state.Done && this.state.Done.length > 0 ? (
                    this.state.Done.map((x) => {
                      if (x.fieldTypeName === "textarea") {
                        return (
                          <Row span={24}>
                            <Col md={12} sm={24}>
                              <Form.Item>
                                <fieldset
                                  style={{ height: "auto" }}
                                  className="mi_input_pop"
                                >
                                  <legend className="legend-font">
                                    {x.fieldLabelName}
                                  </legend>

                                  <Input.TextArea
                                    disabled
                                    type="text"
                                    style={{ height: "100px" }}
                                    autoComplete={"nope"}
                                    className="mi_input"
                                    placeholder={x.fieldPlaceHolder}
                                  />
                                </fieldset>
                              </Form.Item>
                            </Col>
                          </Row>
                        );
                      }
                      if (x.fieldTypeName === "date") {
                        return (
                          <Row span={24}>
                            <Col md={12} sm={24}>
                              <Form.Item>
                                <fieldset className="mi_input_pop">
                                  <legend className="legend-font">
                                    {" "}
                                    {x.fieldLabelName}
                                  </legend>

                                  <DatePicker
                                    disabled
                                    autoComplete={"nope"}
                                    format="MM/DD/YYYY"
                                    className="mi_input"
                                    placeholder={x.fieldPlaceHolder}
                                  />
                                </fieldset>
                              </Form.Item>
                            </Col>
                          </Row>
                        );
                      }
                      if (x.fieldTypeName === "text") {
                        return (
                          <Row span={24}>
                            <Col md={12} sm={24}>
                              <Form.Item>
                                <fieldset
                                  style={{ height: "auto" }}
                                  className="mi_input_pop"
                                >
                                  <legend className="legend-font">
                                    {x.fieldLabelName}
                                  </legend>

                                  <Input
                                    disabled
                                    className="mi_input"
                                    maxLength={40}
                                    type="text"
                                    placeholder={x.fieldPlaceHolder}
                                  />
                                </fieldset>
                              </Form.Item>
                            </Col>
                          </Row>
                        );
                      }
                      if (x.fieldTypeName === "email") {
                        return (
                          <Row span={24}>
                            <Col md={12} sm={24}>
                              <Form.Item>
                                <fieldset
                                  style={{ height: "auto" }}
                                  className="mi_input_pop"
                                >
                                  <legend className="legend-font">
                                    {x.fieldLabelName}
                                  </legend>

                                  <Input
                                    disabled
                                    className="mi_input"
                                    maxLength={40}
                                    type="text"
                                    placeholder={x.fieldPlaceHolder}
                                  />
                                </fieldset>
                              </Form.Item>
                            </Col>
                          </Row>
                        );
                      }
                      if (x.fieldTypeName === "radio") {
                        return (
                          <Row span={24}>
                            <Col md={12} sm={24}>
                              <Form.Item>
                                <legend
                                  className="legend-font"
                                  style={{
                                    marginLeft: "14px",
                                  }}
                                >
                                  {x.fieldLabelName}
                                </legend>

                                <Radio.Group
                                  disabled
                                  style={{
                                    marginLeft: "16px",
                                    marginTop: "20px",
                                  }}
                                  // onChange={this.onChange}
                                  // value={this.state.gendr}
                                >
                                  <Radio className="micompradio" value="male">
                                    Male
                                  </Radio>
                                  <Radio className="micompradio" value="female">
                                    Female
                                  </Radio>
                                </Radio.Group>
                              </Form.Item>
                            </Col>
                          </Row>
                        );
                      }
                    })
                  ) : (
                    <Empty></Empty>
                  )}
                  <Row></Row>
                </Form>
              )}
              <Row span={24} style={{ marginTop: "30px" }}>
                <Col span={5}>
                  {!this.state.isPreview &&
                  this.state.Done &&
                  this.state.Done.length > 0 ? (
                    <Button
                      htmlType="button"
                      className="submit-button"
                      type="primary"
                      // onClick={this.showModal}
                      onClick={() => {
                        this.setState({
                          isPreview: true,
                        });
                      }}
                    >
                      Preview
                    </Button>
                  ) : (
                    ""
                  )}

                  {this.state.isPreview &&
                  this.state.Done &&
                  this.state.Done.length > 0 ? (
                    <Button
                      htmlType="button"
                      className="submit-button"
                      type="primary"
                      // onClick={this.showModal}
                      onClick={() => {
                        this.setState({
                          isPreview: false,
                        });
                      }}
                    >
                      Back
                    </Button>
                  ) : (
                    ""
                  )}
                </Col>

                <Col span={7}></Col>
              </Row>
            </div>
          </div>
          <Row span={24} style={{ marginTop: "30px" }}>
            <Row span={24} style={{ marginTop: "30px" }}>
              <Col span={7}></Col>

              <Col span={5}>
                <Button
                  className="mi_button_right submit-button"
                  onClick={() => {
                    this.props.history.push("/administration/managetemplate");
                  }}
                  style={{ marginRight: 8 }}
                >
                  Cancel
                </Button>
              </Col>
              <Col span={5}>
                {!this.props.location.state ? (
                  <Button
                    onClick={() =>
                      this.setState({
                        visible: true,
                      })
                    }
                    className="submit-button"
                    htmlType="button"
                    type="primary"
                    style={{ marginRight: 8 }}
                    disabled={this.state.Done.length === 0}
                  >
                    Save As
                  </Button>
                ) : (
                  <Button
                    htmlType="button"
                    className="submit-button"
                    type="primary"
                    onClick={this.handleClick}
                    style={{ marginRight: 8 }}
                    disabled={this.state.Done.length === 0}
                  >
                    Save
                  </Button>
                )}
              </Col>
            </Row>
            <Col span={7}></Col>
          </Row>
        </div>
      </Content>
    );
  }
}

const AddTemplate = Form.create()(FD);

export default AddTemplate;
